import $http from '@/resource';
import utils from '@/utils';
import Cache from '@/cache';
import Config from "@/config.js";
import {Message, Notice} from 'view-design';

const $api = {};


/**
 * 获取图形验证码
 * @param {string} type 类型
 *
 * @returns {Promise<any>}
 */
$api.getCodes = function(type) {
	const url = `verify-obtain/${type}`;
	const promise = new Promise(function(resolve){
		$http.get(url).then(function (response) {
		  	if (response.captchaUrl && response.captchaUuid) {
		  	  	resolve(response);
		  	}else{
		  		utils.notice('获取验证码失败', 'error');
		  	}
		});
	});
  	return promise;
};

/**
 * 发送短信（包括了图形验证码的验证）
 *
 * @param {Object} data 含有手机号、图形验证码
 *
 * @returns {Promise<any>}
 */
$api.notifyRequest = function(data) {
	const url = 'notify-request';
	const promise = new Promise(function(resolve, reject){
		$http.post(url, data).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve();
		  	}else{
		  		reject(response);
		  	}
		});
	});
  	return promise;
};


/**
 * 登录短信发送
 *
 * @param {Object} data 含有手机号、图形验证码
 *
 * @returns {Promise<any>}
 */
$api.notifyLogin = function(data) {
    const url = 'notify-login';
    const promise = new Promise(function(resolve, reject){
        $http.post(url, data).then(function (response) {
            if (response.code == 200) {
                resolve();
            }else{
                reject(response);
            }
        });
    });
    return promise;
};

/**
 * 通过父级id获取所有子级地区备选项
 *
 * @param {string} id 父级地区id
 *
 * @date 2018-8-10 17:28:57
 *
 * @returns {Promise<any>}
 */
$api.getAddressList = id => {
    const url = "region/"+id;
    const promise = new Promise(resolve => {
        $http.get(url).then(response => {
            if (response.code === '200') {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });

    return promise;
};

/**
 * 获取单位所有用户或部门备选项[部门带横线]
 *
 * @param {string} type 返回数据类型 all-用户和部门，group-部门,user-用户
 * @param {string} companyId 单位id
 *
 * @date 2018-10-17 09:58:06
 *
 * @returns {Promise<any>}
 */
$api.getCompanyUserGroup = (type="all", companyId=0) => {
    let url;
    if(companyId == 0){
        url = "company-users";
    }else{
        url = `company-users/${companyId}`;
    }
    const promise = new Promise(resolve => {
        $http.get(url).then(response => {
            if (response.code === '200') {
                let data;
                switch(type){
                    case "all":
                        data = response.data;
                        break;
                    case "user":
                        data = response.data.user;
                        break;
                    case "group":
                        data = response.data.group;
                        break;
                    default:
                        data = response.data;
                        break;
                }
                resolve(data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });

    return promise;
};

/**
 * 获取部门用户二级联动备选项并整理成好用的格式[部门带横线]
 *
 * @params {Bool} more 部门选项中是否要包含额外的手动添加的选项
 *
 * @date 2018-8-15 20:50:28
 *
 * @returns {Promise<any>}
 */
$api.getGroupRelateUser = (more=false)=>{
    const url = "company-users";
    const promise = new Promise(resolve => {
        $http.get(url).then(response => {
            if (response.code === '200') {

                let res = response.data;
                let users = res.user;
                let result = [];
                for(let i = 0;i<res.group.length;i++){
                    let item = {
                        'id'    :   res.group[i].id,
                        'name'  :   res.group[i].name,
                        'user'  :   users[res.group[i].id] ? users[res.group[i].id] : [],
                    };
                    for(let m in res.group[i].sonid){
                        if(users[res.group[i].sonid[m]]){
                            item.user = item.user.concat(users[res.group[i].sonid[m]])
                        }
                    }
                    result.push(item);
                }

                //判断是否要添加选哪官方的手动拼接的选项
                // if(more === true){
                //     let moreItem = Config.groupMoreItem;
                //     if(Object.keys(moreItem).length > 0){
                //         for(let v in moreItem){
                //             let addOne = {
                //                 'id'    :  v,
                //                 'name'  :  moreItem[v],
                //                 'user'  :  []
                //             };
                //             result.unshift(addOne);
                //         }
                //     }
                // }

                result = [].concat(result);
                resolve(result);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });

    return promise;
};

/**
 * 意见反馈
 *
 * @param {Object} data 表单数据
 *
 * @returns {Promise<any>}
 */
$api.feedback = (data) => {
    const url = 'feedback';
    const promise = new Promise(function(resolve){
        $http.post(url, data).then(function (response) {
            if (response.code == 200) {
                utils.message({title: response.msg}, 'success');
                resolve();
            }else{
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 退出
 *
 * @returns {Promise<any>}
 */
$api.userLogout = () => {
    const url = 'user-logout';
    const promise = new Promise(function(resolve){
        $http.put(url).then(function (response) {
            if (response.code == 200) {
                resolve();
            }else{
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 获取产业分类备选项
 *
 * @date 2018-8-18 11:08:03
 *
 * @returns {Promise<any>}
 */
$api.getIndustryKindList = ()=>{
    const url = "industry";
    const promise = new Promise(resolve => {
        $http.get(url).then(response => {
            if (response.code === '200') {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 删除文件
 *
 * @param {object} data 相关参数
 * @param {string} url 上传url
 *
 * @returns {Promise<any>}
 */
$api.delUpload = (data,url="del-upload")=>{
    const promise = new Promise(resolve => {
        $http.put(url, data).then(response => {
            if (response.code == 200) {
                utils.notice(response.msg, 'success');
                resolve();
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 附件相机文件复制到pic表
 *
 * @param {array} data 附件相机文件ids
 *
 * @returns {Promise<any>}
 */
$api.cameraToPic = (data)=>{
    const url = "camera-to-pic";
    const promise = new Promise(resolve => {
        $http.post(url, data).then(response => {
            if (response.code == 200) {
                resolve(response.data);
            }
        });
    });
    return promise;
};

/**
 * 获取公共信息
 *
 * @returns {Promise<any>}
 */
$api.getCommomInfo = ()=>{
    const url = 'commom-info';
    const promise = new Promise(resolve => {
        $http.get(url).then(response => {
            if (response.code == 200) {
                resolve(response.data);
            }else{
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};



$api.getUserBase = (uid)=>{
    const url = `users/${uid}`;
    const promise = new Promise(resolve => {
        $http.get(url).then(response => {
            if (response.code == 200) {
                resolve(response.data);
            }else{
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

/**
 * 获取当前用户的所有权限
 *
 * @returns {Promise<any>}
 */
$api.getUserPermissions = ()=>{
    const url = 'plugin/user-permissions';
    const promise = new Promise(resolve => {
        $http.get(url).then(response => {
            if (response.code == 200) {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        })
    });
    return promise;
};

/**
 * 获取首页相关待处理数
 *
 * @param {string} routeGroup 路由分组
 *
 * @returns {Promise<any>}
 */
$api.getCountWaitToHeadle = (routeGroup)=>{
    const url = 'red-counts';
    const promise = new Promise(resolve => {
        $http.get(url, {params: {group: routeGroup}}).then(response => {
            if (response.code == 200) {
                resolve(response.data);
            } else {
                utils.notice(response.msg, 'error');
            }
        })
    });
    return promise;
};


/**
 * 根据类型获取单文件下载地址
 *
 * @param {string} type 类型
 * @param {object} param 路由携带参数
 *
 * @date 2018-10-11 14:36:30
 *
 * @return {string}
 */
$api.getDownloadUrlByType = (type,param={})=>{
    let list = {
        //项目附件
        "itemFile"   :  `item/${param.id}/attachment?fileId=${param.fileId}`,
        "carrierFile":  `carrier/${param.id}/attachment?fileId=${param.fileId}`,
        "companyFile":  `companyFile/${param.id}/attachment?fileId=${param.fileId}`,
        "commonFile" :  `plugin/common-attachment?fileId=${param.fileId}`,
    };

    if(!type || !list[type]){
        return "";
    }

    return list[type];
};

/**
 * 导出Office文件
 *
 * @param {string} url 请求地址
 * @param {function} callback 回调操作函数
 * @param {string} name 下载文件名[带后缀]
 *
 * @date 2018-9-28 16:16:23
 *
 * @returns {Promise<any>}
 */
$api.downloadOfficeFile = (url,callback=()=>{},name="") => {
    const promise = new Promise(resolve => {
        $http.get(url, {responseType: 'blob'}).then(response => {
            callback();
            if (!response || response.size === 0) {
                utils.notice("下载失败,超时或文件不存在，请重试", 'error');
            } else {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                name = name === "" ? Date.parse(new Date())+".xls" : name;
                // link.click();
                link.setAttribute('download', name);
                // document.body.appendChild(link);
                link.click();
            }
        })
    });
    return promise;
};

/**
 * 获取联系人备选项数据
 *
 * @param {string} contactType 包含联系人类型 1：最近联系人 2：常用联系人 3：官方联系人
 * @param {object} params {type:string类型1项目2载体,typeId:string项目/载体id} 额外参数，当contactType包含3的时候必传对应内容
 *
 * @date 2018-10-22 11:55:01
 *
 * @returns {Promise<any>}
 */
$api.getContactList = (contactType="1,2",params={})=>{
    let url = `contact-users?contactType=${contactType}`;
    if(Object.keys(params).length > 0){
        for(let i in params){
            url += `&${i}=${params[i]}`;
        }
    }
    const promise = new Promise((resolve)=>{
        $http.get(url).then( (response)=>{
            resolve(response);
        });
    });
    return promise;
};

/**
 * 查询并搜索最近|常用联系人
 *
 * @param {string} keyword 搜索关键字
 * @param {string} type 类型 recent-最近联系人，frequent-常用联系人
 *
 * @date 2018-9-30 10:19:28
 *
 * @returns {Promise<any>}
 */
$api.getRecentContactUsers = (keyword="",type="recent")=>{
    let str = "";
    switch(type){
        case "recent":
            str = "1";
            break;
        case "frequent":
            str = "2";
            break;
        default:
            str = "1,2";
            break;
    }
    const promise = new Promise((resolve)=>{
        $api.getContactList(str).then(res=>{
            if(res.code !== "200"){
                resolve(res);
                return false;
            }else{
                let result = {
                    nearBy : [],
                    always : [],
                };
                if(keyword !== "" && keyword){
                    if(str.indexOf("1") !== -1){
                        //最近联系人
                        result.nearBy = [];
                        for(let i=0; i<res.data.nearBy.length ;i++){
                            if(res.data.nearBy[i].username.indexOf(keyword) !== -1){
                                result.nearBy.push({uid:res.data.nearBy[i].uid,username:res.data.nearBy[i].username});
                            }
                        }
                    }
                    if(str.indexOf("2") !== -1){
                        //常用联系人
                        result.always = [];
                        for(let i=0; i<res.data.always.length ;i++){
                            if(res.data.always[i].username.indexOf(keyword) !== -1){
                                result.always.push({uid:res.data.always[i].uid,username:res.data.always[i].username});
                            }
                        }
                    }
                }else{
                    result = res.data;
                }
                let list;
                switch (type){
                    case "recent":
                        list = result.nearBy;
                        break;
                    case "frequent":
                        list = result.always;
                        break;
                    default:
                        list = result;
                        break;
                }
                let ret = {"code":"200","data":list,"msg":""};
                resolve(ret);
            }
        });
    });
    return promise;
};

/**
 * 用来给移动端做页面跳转的方法
 * @param {string} source 端代号ios/android
 * @param {string} fncName 伪装方法的方法名
 * @param {string} data 整整要跳转的路由地址
 * @returns {bool}
 */
$api.sendHttpRequestToMobile = (source="",fncName="",data={})=>{
    if(!source || !fncName || !data){
        return false;
    }
    switch(source){
        case "ios":
            window.webkit.messageHandlers[fncName].postMessage(data);
            break;
        case "android":
            location.href = `${fncName}/?jsonAndroidTk=${JSON.stringify(data)}`;
            break;
        default:
            break;
    }
    return true;
};

/**
 * 获取安卓的最新apk下载地址
 *
 * @date 2019年1月14日10:13:27
 *
 * @returns {Promise<any>}
 */
$api.getAndroidDownloadUrl = ()=>{
    const url = `android-unlogin`;
    const promise = new Promise(resolve => {
        $http.get(url).then(response => {
            resolve(response);
        });
    });
    return promise;
};


$api.getAuthUsers = async (auth) => {
    const url = `auth-groupusers?auth=${auth}`;
    let res = await $http.get(url);
    if (res.code == "200") {
        return res.data;
    } else {
        utils.notice(res.msg, 'error');
    }
}

$api.getAuthUserList = async (auth, search) => {
    const url = `auth-users?auth=${auth}&${utils.objToUrlParams(search)}`;
    let res = await $http.get(url);
    if (res.code == "200") {
        return res.data;
    } else {
        utils.notice(res.msg, 'error');
    }
}

export default $api;



// WEBPACK FOOTER //
// ./src/service/common.js